import React, { useEffect } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import HubspotEmbedForm from '../../Forms/HubspotEmbed';
import { Container } from '../styles/FooterNewsletter.styled';
import { handleUTMsEvent } from '../../Forms/Utilities/hubspotEmbedGetUTMs';

const FooterNewsletter = () => {
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener('hs-form-event:on-ready', handleUTMsEvent);

    return () => {
      window.removeEventListener('hs-form-event:on-ready', handleUTMsEvent);
    };
  }, []);

  return (
    <Container id="footer-newsletter">
      <p className="heading">{t('Sign up for newsletter!')}</p>
      <p className="subhead">
        {t(
          'Our weekly newsletter full of inspiration, podcasts, trends & news.'
        )}
      </p>
      <HubspotEmbedForm
        portalId="243522351"
        formId="02a5c1ce-da55-4b39-a968-31001d9b6e15"
        region="na2"
      />
    </Container>
  );
};

export default FooterNewsletter;
